import { format, parseISO } from 'date-fns';

export const formatDate = (date: Date | string, dateFormat: string): string => {
  if (!date || !dateFormat) {
    return '';
  }

  return format(new Date(date), dateFormat);
};

export const formattedIsoDate = (date: string) => new Date(date).toISOString().replace('Z', '');

export const formatDateString = (datestring: string, dateFormat: string): string => {
  if (!datestring || !dateFormat) {
    return '';
  }

  return format(parseISO(datestring), dateFormat);
};

export const cleanDateText = (date: string) => date.replace(/[^0-9\/]/g, '');
